import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';

import Textinput from '../components/textinput';

//Actions
import * as appActions from '../actions/appActions';
import * as userActions from '../actions/userActions';

import { getCookie } from '../services/cookie';

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.submitLogin = this.submitLogin.bind(this);

        const lastLogin = getCookie('last_login') || '';

        this.initialState = {
            email:  lastLogin,
            password: '',
            formErrors: {email: '', password: ''},
            emailValid: lastLogin !== '',
            passwordValid: false,
            submitCliked: false
        }
        this.state = this.initialState;
    }

    componentDidMount() {
        document.addEventListener('keypress', e => {
            if (e.keyCode == 13 && this.props.appState.isLoginVisible && !this.props.appState.isPopupVisible) {
                this.submitLogin();
            }
        })
    }
    componentWillUnmount() {
        document.removeEventListener('keypress', e => {
            if (e.keyCode == 13 && this.props.appState.isLoginVisible && !this.props.appState.isPopupVisible) {
                this.submitLogin();
            }
        })
    }

    closeLogin(e) {
        if (e.target.getAttribute('name') == 'loginPopup') {
            this.props.actions.hideLogin();
            if (!this.state.emailValid || !this.state.passwordValid) {
                this.setState(this.initialState);
            }
        }
    }

    submitLogin() {
        let { email, password, emailValid, passwordValid } = this.state;

        this.setState({
            ...this.state,
            submitCliked: true,
        });
        if (emailValid && passwordValid) {
            this.props.actions.submitLogin({
                email: email,
                password: password,
            }, () => this.setState({ password: ''}));
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            [name]: value
        }, () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let emailValid = this.state.emailValid;
        let passwordValid = this.state.passwordValid;

        switch(fieldName) {
            case 'email':
              emailValid = !!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
              fieldValidationErrors.email = emailValid ? '' : 'is not valid';
              break;
            case 'password':
              passwordValid = value.length >= 3;
              fieldValidationErrors.password = passwordValid ? '': 'is not valid';
              break;
            default:
              break;
          }
          this.setState({
              formErrors: fieldValidationErrors,
              emailValid: emailValid,
              passwordValid: passwordValid
          });
    }

	render() {
        const { isLoginVisible, isSessionExpired, isPasswordReset } = this.props.appState;
        const { emailValid, passwordValid, submitCliked, formErrors } = this.state;

        let emailLabel = !emailValid && submitCliked ? `Email ${formErrors.email}` : 'Email';
        let passwordLabel = !passwordValid && submitCliked ? `Password ${formErrors.password}` : 'Password';
        let title = 'Welcome Back!';
        if (isSessionExpired) {
            title = 'Direct Hedge session has expired\nPlease log in again';
        }
        else if (isPasswordReset) {
            title = 'Password reset successfully\nPlease log in again';
        }

        return (
            <div name='loginPopup' className='login-container generic-popup-container'
              onClick={ this.closeLogin.bind(this) }
              style={{display: isLoginVisible ? 'block' : 'none' }}>

              <div className='form'>

                <div id='login'>

                    <h1 className={isSessionExpired ? 'shrinked' : ''}>{title}</h1>

                    <Textinput
                        label={emailLabel}
                        name='email'
                        value={ this.state.email }
                        onChange={ this.handleChange }
                        required={true}
                        invalid={!emailValid && submitCliked}
                        type='email' />

                    <Textinput
                        label={passwordLabel}
                        name='password'
                        value={ this.state.password }
                        onChange={ this.handleChange }
                        required={true}
                        invalid={!passwordValid && submitCliked}
                        type='password' />

                    <p className='forgot'>
                        <Link to='forgot_password'>
                            Forgot Password?
                        </Link>
                    </p>
                    <button
                        onClick={ this.submitLogin }
                        className='button button-block'>Log In</button>

                </div>
              </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        userState: state.user,
        appState: state.app
    }),
    dispatch => ({
        actions: bindActionCreators({...appActions, ...userActions}, dispatch)
    })
)(Login);



// WEBPACK FOOTER //
// ./source/components/login.js